import React from "react";

import toast from "react-hot-toast";
import { HiArrowLeft } from "react-icons/hi";
import {
  Link,
  Outlet,
  matchPath,
  useLocation,
  useParams,
  useNavigate,
} from "react-router-dom";

import { useDeleteMember } from "../../api/deleteMember";
import { useLeague } from "../../api/league";
import { useProfile } from "../../api/profile";
import useAuth from "../../hooks/useAuth";
import Button from "../Button";
import ConfirmationDialog from "../ConfirmationDialog";
import Header from "../Header";

const LeagueLayout = ({ children }) => {
  const { token } = useAuth();
  const params = useParams();
  const { pathname } = useLocation();
  const isManage = matchPath("/my-leagues/:leagueId/manage", pathname);
  const { data: currentUser } = useProfile()
  const { data } = useLeague({ id: params.leagueId });

  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const [isAdmin, setIsAdmin] = React.useState(false);

  const league = React.useMemo(() => data?.data, [data?.data]);

  const navigate = useNavigate()

  const { execute } = useDeleteMember()

  const user = React.useMemo(() => {

    console.log('--------------------------------');
    console.log('league', league);
    console.log('params.leagueId', params.leagueId);
    console.log('currentUser', currentUser);
    console.log('--------------------------------');

    // Use the single league data instead of searching through all leagues
    const members = league?.members;

    console.log('members', members);

    const user = members?.find(
      (member) => member.memberId === currentUser?.id
    );

    console.log('user', user);

    return user;

  }, [league, currentUser]);


  const handleDeleteMember = React.useCallback(async () => {


    console.log('--------------------------------');
    console.log('user', user);
    console.log('--------------------------------');

    await execute({ ID: user?.ID, SK: user?.SK })
    setShowConfirmation(false);
    toast.success("You have left the league");
    navigate(`/my-leagues/`)
  }, [execute, user?.ID, user?.SK, navigate]);


  const isMember = React.useMemo(
    () => token && !!user,
    [token, user]
  );

  React.useEffect(() => {
    if (user) {
      setIsAdmin(user?.details.makeAdmin);
    }
  }, [user])

  if (isManage) {
    return (
      <div className="flex h-screen flex-col">
        <Header>
          <Header.Left>
            <Link to="../my-leagues">
              <HiArrowLeft className="h-6 w-6 text-white" />
            </Link>
          </Header.Left>
          <Header.Center>
            <span className="font-semibold text-white">Manage League</span>
          </Header.Center>
          <Header.Right />
        </Header>
        <main className="flex-1 overflow-y-auto p-4">
          {children ? children : <Outlet />}
        </main>
      </div>
    );
  }

  return (
    <>
      <ConfirmationDialog
        showModal={showConfirmation}
        setShowModal={setShowConfirmation}
        title="Are you sure you want to leave this league?"
        click={handleDeleteMember}
      />
      <div className="flex h-screen flex-col">
        <Header>
          <Header.Left>
            <Link to="../my-leagues">
              <HiArrowLeft className="h-6 w-6 text-white" />
            </Link>
          </Header.Left>
          <Header.Center>
            <span className="font-semibold text-white">
              {league?.details.title}
            </span>
          </Header.Center>
          <Header.Right>
            {!isMember ? (
              <Link
                to={`join/${league?.invitationCode}`}
                className="text-violet-400 hover:underline"
              >
                Join
              </Link>
            ) : (<>
              {isAdmin === false && (
                <Button onClick={() => setShowConfirmation(true)} className="text-white text-sm py-1 rounded-md">Leave</Button>
              )}
            </>
            )}
          </Header.Right>
        </Header>
        <main className="flex-1 overflow-y-auto p-4">
          {children ? children : <Outlet />}
        </main>
      </div>
    </>
  );
};

export default LeagueLayout;
